import type { Accessory } from '@/features/basket/types/accessory';
import type { Product } from '@/features/basket/types/product';
import { ga4_addToCart } from '@/libs/ga4/actions/add-to-cart';
import { ga4_removeFromCart } from '@/libs/ga4/actions/remove-from-cart';

type Props = {
  product: Product | Accessory;
  quantity: number;
  newQuantity: number;
};

export function ga4_changeQuantity({ product, quantity, newQuantity }: Props) {
  if (newQuantity > quantity) {
    ga4_addToCart(product, newQuantity - quantity);
  } else {
    ga4_removeFromCart(product, quantity - newQuantity);
  }
}
